
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/growthhack/done",
      function () {
        return require("private-next-pages/download/growthhack/done/index.tsx");
      }
    ]);
  